<template>
  <main class="page-operative page-operative-settings">
    <div class="container">
      <PageTitle class="mb-5">Impostazioni</PageTitle>

      <div class="alert alert-warning" role="alert">
        <h4 class="alert-heading">
          <i class="fas fa-exclamation-triangle mr-3"></i>
          Attenzione
        </h4>
        <p>
          I dati inseriti sono da intendere al solo scopo di produrre delle previsioni in grado di fornire un'indicazione sugli andamenti futuri della società.
        </p>
        <hr>
        <p class="mb-0">I dati non possono essere utilizzati per dichiarazioni fiscali o simili e non sostituiscono le risultanze contabili ufficiali.</p>
      </div>

      <!--<div v-if="feedback === true" class="alert alert-success">Impostazioni salvate</div>-->

      <SettingsForm v-if="settings" :settings="settings" :hasProjects="isModuleProjectsEnabled" edit @submitForm="saveSettings" class="mb-5" />
    </div>
  </main>
</template>

<script>
import operativePageMixin from '@/mixins/operativePage';
import { companyHasModule } from '@/helpers/modules';

export default {
  name: 'Settings',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    SettingsForm: () => import('@/views/pages/Operative/Utilities/SettingsForm'),
  },
  data () {
    return {
      settings: null,
    };
  },
  computed: {
    isModuleProjectsEnabled () {
      return companyHasModule(this.company, 'PROJECTS');
    },
  },
  methods: {
    saveSettings () {
      this.$api.saveSettings(this.company.id, this.settings)
        .then(() => {
          this.makeToast('success', 'Buone notizie!', 'Impostazioni salvate');
        })
        .catch(this.$log.error)
      ;
    },
    makeToast (variant = null, title = '', content = 'Success') {
      this.$bvToast.toast(content, {
        title: title,
        toaster: 'b-toaster-top-right',
        solid: true,
        variant: variant,
        appendToast: true,
      });
    },
  },
  watch: {
    company: {
      handler: function () {
        if (!this.company) {
          return;
        }
        this.$api.getSettings(this.company.id)
          .then(res => {
            this.settings = res.data || {};
          })
          .catch(this.$log.error)
        ;
      },
      immediate: true,
    },
  },
};

</script>

<style lang="scss">

</style>
